import { render, staticRenderFns } from "./PlatformDisplay.vue?vue&type=template&id=6fc18d47"
import script from "./PlatformDisplay.vue?vue&type=script&lang=js"
export * from "./PlatformDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports